import styled from 'styled-components';
import { CardContent } from '@material-ui/core';

const CardTitleContent = styled(CardContent)`
  display: flex;
  align-items: center;
  padding-bottom: 0;
  .card-title {
    flex: 1;
    padding: 0;
  }
  .MuiButtonBase-root,
  .btn-container {
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
`;

export default CardTitleContent;
